import type { Matrix } from '@babylonjs/core';
import { Vector3 } from '@babylonjs/core';

import { BoundingBox } from '../loading-v2/OctreeGeometry';

/**
 * Computes a transformed bounding box
 */
export function computeTransformedBoundingBox(
  box: BoundingBox,
  transform: Matrix,
): BoundingBox {
  // 8つの頂点を変換
  const corners = [
    new Vector3(box.min.x, box.min.y, box.min.z),
    new Vector3(box.max.x, box.min.y, box.min.z),
    new Vector3(box.min.x, box.max.y, box.min.z),
    new Vector3(box.min.x, box.min.y, box.max.z),
    new Vector3(box.min.x, box.max.y, box.max.z),
    new Vector3(box.max.x, box.max.y, box.min.z),
    new Vector3(box.max.x, box.min.y, box.max.z),
    new Vector3(box.max.x, box.max.y, box.max.z),
  ];

  // 各頂点を変換
  for (let i = 0; i < corners.length; i++) {
    Vector3.TransformCoordinatesToRef(corners[i], transform, corners[i]);
  }

  // 変換された頂点から新しいバウンディングボックスを計算
  let minX = Number.POSITIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let minZ = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let maxY = Number.NEGATIVE_INFINITY;
  let maxZ = Number.NEGATIVE_INFINITY;

  for (const corner of corners) {
    minX = Math.min(minX, corner.x);
    minY = Math.min(minY, corner.y);
    minZ = Math.min(minZ, corner.z);
    maxX = Math.max(maxX, corner.x);
    maxY = Math.max(maxY, corner.y);
    maxZ = Math.max(maxZ, corner.z);
  }

  return new BoundingBox(
    new Vector3(minX, minY, minZ),
    new Vector3(maxX, maxY, maxZ),
  );
}

export function createChildAABB(aabb: BoundingBox, index: number): BoundingBox {
  const min = aabb.min.clone();
  const max = aabb.max.clone();
  const size = max.subtract(min);

  // tslint:disable-next-line:no-bitwise
  if ((index & 0b0001) > 0) {
    min.z += size.z / 2;
  } else {
    max.z -= size.z / 2;
  }

  // tslint:disable-next-line:no-bitwise
  if ((index & 0b0010) > 0) {
    min.y += size.y / 2;
  } else {
    max.y -= size.y / 2;
  }

  // tslint:disable-next-line:no-bitwise
  if ((index & 0b0100) > 0) {
    min.x += size.x / 2;
  } else {
    max.x -= size.x / 2;
  }

  return new BoundingBox(min, max);
}
